<template>
    <slot></slot>

    <Footer />

    <div
        v-show="scrollPosition > 300"
        class="scroll-to-top"
        @click="toTop"
    ></div>
</template>

<script setup>
import { ref } from 'vue';
import Footer from './components/Footer-index.vue';

const scrollPosition = ref(0);

if (typeof window !== 'undefined') {
    window.addEventListener('scroll', handleScroll);
}

function handleScroll() {
    scrollPosition.value = window.scrollY;
}

function toTop() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
}

</script>
<style scoped lang="scss">
.scroll-to-top {
  display: flex;
  position: fixed;
  cursor: pointer;
  background-color: #0000004d;
  border-radius: 4px;
  padding: 8px;
  right: 16px;
  bottom: 16px;
  transition-timing-function: cubic-bezier(0,0,.2,1);
  transition-duration: .3s;

  &:hover {
    bottom: 20px;
  }
}
</style>
